import { apiWithoutAuth } from '@/shared/api/instances';
import { authPaths } from '@/entities/auth/api/paths';

import type { ApiResponse } from '@shared/types';

/** 서버 로그아웃이 오래 걸려도 사용자를 붙잡지 않는다 — 이 시간이 지나면 요청을 포기한다(로컬 로그아웃은 이미 끝났다). */
export const SERVER_LOGOUT_TIMEOUT_MS = 3000;

/**
 * 서버 응답의 폐기 결과 해석. 계약(dev 실응답 2026-10-02): `{message, result: {result: "true" | "false"}}` — 불리언이 아니라 **문자열**이다.
 * "false" = 그 키를 지우지 못했다(이미 만료·없는 키·형식 오류). 모양이 다르면 false 로 본다.
 */
export const parseRevokeResult = (body: unknown): boolean => {
  const result = (body as ApiResponse<{ result?: unknown }> | null | undefined)?.result?.result;
  return result === true || result === 'true';
};

/**
 * TRAD-3590 — 리프레시 토큰 키를 서버에서 폐기한다(`POST /api/auth/logout`, JWT 불필요).
 * TRAD-3861 — 키는 서버 HttpOnly 쿠키(Path=/api/auth)가 자동 동봉한다 → body 는 비운다. 서버가 `Set-Cookie: …; Max-Age=0` 으로 지운다.
 * 종전 웹 로그아웃은 쿠키만 지워서 로그아웃한 뒤에도 같은 키로 재발급이 200 이었다(dev 실측).
 * 호출부는 결과를 기다리지 않는다(best-effort): 실패해도 로컬 로그아웃은 이미 진행된다.
 */
/** 로그아웃 요청 body — 순수 함수(테스트용 export). 이행기 옛 JS 쿠키 키가 있을 때만 `refreshTokenKey` 동봉, 평소엔 `{}`(키는 HttpOnly 쿠키가 동봉). */
export const buildLogoutBody = (legacyKey: string | undefined): Record<string, string> =>
  legacyKey ? { refreshTokenKey: legacyKey } : {};

export const revokeRefreshTokenOnServer = async (legacyKey?: string): Promise<boolean> => {
  const { data } = await apiWithoutAuth.post<ApiResponse<{ result: string }>>(
    authPaths.logout,
    buildLogoutBody(legacyKey),
    { timeout: SERVER_LOGOUT_TIMEOUT_MS },
  );
  return parseRevokeResult(data);
};
